// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*-----------------------------------------------------------------------------
| Variables
|----------------------------------------------------------------------------*/

:root {
  /* These need to be root because tabs get attached to the body during dragging. */
  --theia-private-horizontal-tab-height: 28.5px;
  --theia-private-horizontal-tab-scrollbar-rail-height: 7px;
  --theia-private-horizontal-tab-scrollbar-height: 5px;
  --theia-tabbar-toolbar-z-index: 1001;
  --theia-toolbar-active-transform-scale: 1.272019649;
  --theia-horizontal-toolbar-height: calc(var(--theia-private-horizontal-tab-height) + var(--theia-private-horizontal-tab-scrollbar-rail-height) / 2);
  --theia-dragover-tab-border-width: 2px;
}

/*-----------------------------------------------------------------------------
| General tab bar style
|----------------------------------------------------------------------------*/

.p-TabBar {
  font-size: var(--theia-ui-font-size1);
}

.p-TabBar[data-orientation="horizontal"] {
  min-height: var(--theia-horizontal-toolbar-height);
}

.p-TabBar .p-TabBar-content {
  cursor: pointer;
}

.p-TabBar[data-orientation="horizontal"] .p-TabBar-tab {
  flex: none;
  height: var(--theia-horizontal-toolbar-height);
  min-width: 35px;
  line-height: var(--theia-private-horizontal-tab-height);
  padding: 0px 8px;
  align-items: center;
  overflow: hidden;
}

.p-TabBar[data-orientation="vertical"] .p-TabBar-tab {
  border-top: var(--theia-dragover-tab-border-width) solid transparent !important;
  border-bottom: var(--theia-dragover-tab-border-width) solid transparent !important;
}

.p-TabBar[data-orientation="vertical"] .p-TabBar-tab.drop-target-top {
  border-top-color: var(--theia-activityBar-activeBorder) !important;
}

.p-TabBar[data-orientation="vertical"] .p-TabBar-tab.drop-target-bottom {
  border-bottom-color: var(--theia-activityBar-activeBorder) !important;
}

.p-TabBar[data-orientation="horizontal"] .p-TabBar-tab .theia-tab-icon-label,
.p-TabBar-tab.p-mod-drag-image .theia-tab-icon-label {
  display: flex;
  line-height: var(--theia-content-line-height);
  align-items: center;
}

/*-----------------------------------------------------------------------------
| Tabs in the center area (main and bottom)
|----------------------------------------------------------------------------*/

#theia-main-content-panel,
#theia-main-content-panel .p-Widget.p-DockPanel-widget {
  background: var(--theia-editor-background);
}

#theia-main-content-panel .p-DockPanel-handle[data-orientation="horizontal"] {
  border-left: var(--theia-border-width) solid var(--theia-editorGroup-border);
}

#theia-main-content-panel .p-DockPanel-handle[data-orientation="vertical"]+.p-TabBar {
  border-top: var(--theia-border-width) solid var(--theia-editorGroup-border);
}

#theia-main-content-panel .p-TabBar .p-TabBar-tab {
  border-right: 1px solid var(--theia-tab-border);
  border-top: 1px solid transparent;
  border-bottom: 1px solid transparent;
  background: var(--theia-tab-inactiveBackground);
  color: var(--theia-tab-inactiveForeground);
}

#theia-main-content-panel .p-TabBar:not(.theia-tabBar-active) .p-TabBar-tab {
  color: var(--theia-tab-unfocusedInactiveForeground);
}

.p-TabBar.theia-app-centers {
  background: var(--theia-editorGroupHeader-tabsBackground);
}

.p-TabBar.theia-app-centers::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  pointer-events: none;
  background-color: var(--theia-editorGroupHeader-tabsBorder);
  width: 100%;
  height: 1px;
}

.p-TabBar.theia-app-centers .p-TabBar-tabIcon,
.p-TabBar.theia-app-centers .p-TabBar-tabLabel,
.p-TabBar.theia-app-centers .p-TabBar-tabLabelDetails,
.p-TabBar.theia-app-centers .p-TabBar-tabCloseIcon {
  display: inline-block;
}

.p-TabBar.theia-app-centers .p-TabBar-tabLabelDetails {
  margin-left: 5px;
  color: var(--theia-descriptionForeground);
  flex: 1 1 auto;
  overflow: hidden;
  white-space: nowrap;
}

.p-TabBar-tail {
  padding-left: 5px;
  text-align: center;
  justify-content: center;
}

.p-TabBar.theia-app-centers .p-TabBar-tabLabelWrapper {
  display: flex;
}

.p-TabBar-tab-secondary-label {
  color: var(--theia-settings-headerForeground);
  cursor: pointer;
  font-size: var(--theia-ui-font-size0);
  margin-left: 5px;
  text-decoration-line: underline;

  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: linear-gradient(45deg,
      transparent 50%,
      var(--theia-icon-foreground) 50%),
    linear-gradient(135deg, var(--theia-icon-foreground) 50%, transparent 50%);
  background-position: calc(100% - 6px) 8px, calc(100% - 2px) 8px, 100% 0;
  background-size: 4px 5px;
  background-repeat: no-repeat;
  padding: 2px 14px 0 0;
}

.p-TabBar .p-TabBar-tabIcon,
.p-TabBar-tab.p-mod-drag-image .p-TabBar-tabIcon {
  width: 15px;
  line-height: 1.7;
  font-size: 12px;
  text-align: center;
  background-repeat: no-repeat;
}

/* common icons */
.p-TabBar.theia-app-centers .p-TabBar-tabIcon,
.p-TabBar-tab.p-mod-drag-image .p-TabBar-tabIcon {
  min-height: 14px;
  background-size: 13px;
  background-position-y: 3px;
  background: var(--theia-icon-foreground);
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-size: auto 13px;
  mask-repeat: no-repeat;
  mask-size: auto 13px;
  padding-right: 8px;
}

.p-TabBar.theia-app-centers .p-TabBar-tabIcon[class*="plugin-icon-"],
.p-TabBar-tab.p-mod-drag-image .p-TabBar-tabIcon[class*="plugin-icon-"] {
  background: none;
  height: var(--theia-icon-size);
}

.p-TabBar.theia-app-centers .p-TabBar-tabIcon[class*="plugin-icon-"]::before,
.p-TabBar-tab.p-mod-drag-image .p-TabBar-tabIcon[class*="plugin-icon-"]::before {
  display: inline-block;
}

/* codicons */
.p-TabBar.theia-app-centers .p-TabBar-tabIcon.codicon,
.p-TabBar-tab.p-mod-drag-image .p-TabBar-tabIcon.codicon {
  background: none;
}

.p-TabBar-tabLock:after {
  content: "\\ebe7";
  opacity: 0.75;
  margin-left: 4px;
  color: inherit;
  font-family: codicon;
  font-size: 16px;
  font-weight: normal;
  display: inline-block;
  vertical-align: top;
}

/* file icons */
.p-TabBar[data-orientation="horizontal"] .p-TabBar-tabIcon.file-icon,
.p-TabBar-tab.p-mod-drag-image .p-TabBar-tabIcon.file-icon {
  background: none;
  padding-bottom: 0px;
  min-height: 20px;
}

.p-TabBar[data-orientation="horizontal"] .p-TabBar-tabIcon.fa,
.p-TabBar-tab.p-mod-drag-image .p-TabBar-tabIcon.fa {
  background: none;
  min-height: 0;
  height: inherit;
}

.p-TabBar[data-orientation="vertical"] .p-TabBar-tab.p-mod-invisible {
  visibility: hidden;
}

.p-TabBar.theia-app-centers .p-TabBar-tab.p-mod-closable>.p-TabBar-tabCloseIcon,
.p-TabBar.theia-app-centers .p-TabBar-tab.theia-mod-pinned>.p-TabBar-tabCloseIcon {
  padding: 2px;
  margin-top: 2px;
  margin-left: 4px;
  height: var(--theia-icon-size);
  width: var(--theia-icon-size);
  font: normal normal normal 16px/1 codicon;
  display: inline-block;
  text-decoration: none;
  text-rendering: auto;
  text-align: center;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

.p-TabBar.theia-app-centers.dynamic-tabs .p-TabBar-tab.p-mod-closable>.p-TabBar-tabCloseIcon,
.p-TabBar.theia-app-centers.dynamic-tabs .p-TabBar-tab.theia-mod-pinned>.p-TabBar-tabCloseIcon {
  /* hide close icon for dynamic tabs strategy*/
  display: none;
}

.p-TabBar.theia-app-centers .p-TabBar-tab.p-mod-current>.p-TabBar-tabCloseIcon,
.p-TabBar.theia-app-centers .p-TabBar-tab:hover.p-mod-closable>.p-TabBar-tabCloseIcon,
.p-TabBar.theia-app-centers .p-TabBar-tab:hover.theia-mod-pinned>.p-TabBar-tabCloseIcon {
  display: inline-block;
}

.p-TabBar.theia-app-centers .p-TabBar-tab.p-mod-closable>.p-TabBar-tabCloseIcon:hover {
  border-radius: 5px;
  background-color: rgba(50%, 50%, 50%, 0.2);
}

.p-TabBar.theia-app-centers .p-TabBar-tab.p-mod-closable,
.p-TabBar.theia-app-centers .p-TabBar-tab.theia-mod-pinned {
  padding-right: 4px;
}

.p-TabBar.theia-app-centers .p-TabBar-tab.p-mod-closable:not(.theia-mod-dirty):hover>.p-TabBar-tabCloseIcon:before,
.p-TabBar.theia-app-centers .p-TabBar-tab.p-mod-closable:not(.theia-mod-dirty).p-TabBar-tab.p-mod-current>.p-TabBar-tabCloseIcon:before,
.p-TabBar.theia-app-centers .p-TabBar-tab.p-mod-closable.theia-mod-dirty>.p-TabBar-tabCloseIcon:hover:before {
  content: "\\ea76";
}

.p-TabBar.theia-app-centers .p-TabBar-tab.p-mod-closable.theia-mod-dirty>.p-TabBar-tabCloseIcon:before {
  content: "\\ea71";
}

.p-TabBar.theia-app-centers .p-TabBar-tab.theia-mod-pinned>.p-TabBar-tabCloseIcon:before {
  content: "\\eba0";
}

.p-TabBar.theia-app-centers .p-TabBar-tab.theia-mod-pinned.theia-mod-dirty>.p-TabBar-tabCloseIcon:before {
  content: "\\ebb2";
}

.p-TabBar-tabIcon.no-icon {
  display: none !important;
}

.theia-badge-decorator-sidebar {
  background-color: var(--theia-activityBarBadge-background);
  border-radius: 20px;
  color: var(--theia-activityBarBadge-foreground);
  font-size: calc(var(--theia-ui-font-size0) * 0.85);
  font-weight: 600;
  height: var(--theia-notification-count-height);
  width: var(--theia-notification-count-width);
  padding: calc(var(--theia-ui-padding) / 6);
  line-height: calc(var(--theia-content-line-height) * 0.7);
  position: absolute;
  top: calc(var(--theia-ui-padding) * 4);
  right: calc(var(--theia-ui-padding) * 1.33);
  text-align: center;
}

.p-TabBar .theia-badge-decorator-horizontal {
  background-color: var(--theia-badge-background);
  border-radius: 20px;
  box-sizing: border-box;
  color: var(--theia-activityBarBadge-foreground);
  font-size: calc(var(--theia-ui-font-size0) * 0.8);
  font-weight: 400;
  height: var(--theia-notification-count-height);
  width: var(--theia-notification-count-width);
  padding: calc(var(--theia-ui-padding) / 6);
  line-height: calc(var(--theia-content-line-height) * 0.61);
  margin-left: var(--theia-ui-padding);
  text-align: center;
}

/*-----------------------------------------------------------------------------
| Perfect scrollbar
|----------------------------------------------------------------------------*/

.p-TabBar[data-orientation="horizontal"] .p-TabBar-content-container>.ps__rail-x {
  height: var(--theia-private-horizontal-tab-scrollbar-rail-height);
  z-index: 1000;
}

.p-TabBar[data-orientation="horizontal"] .p-TabBar-content-container>.ps__rail-x>.ps__thumb-x {
  height: var(--theia-private-horizontal-tab-scrollbar-height) !important;
  bottom: calc((var(--theia-private-horizontal-tab-scrollbar-rail-height) - var(--theia-private-horizontal-tab-scrollbar-height)) / 2);
}

.p-TabBar[data-orientation="horizontal"] .p-TabBar-content-container>.ps__rail-x:hover,
.p-TabBar[data-orientation="horizontal"] .p-TabBar-content-container>.ps__rail-x:focus {
  height: var(--theia-private-horizontal-tab-scrollbar-rail-height) !important;
}

.p-TabBar[data-orientation="horizontal"] .p-TabBar-content-container>.ps__rail-x:hover>.ps__thumb-x,
.p-TabBar[data-orientation="horizontal"] .p-TabBar-content-container>.ps__rail-x:focus>.ps__thumb-x {
  height: calc(var(--theia-private-horizontal-tab-scrollbar-height) / 2) !important;
  bottom: calc((var(--theia-private-horizontal-tab-scrollbar-rail-height) - var(--theia-private-horizontal-tab-scrollbar-height)) / 2);
}

.p-TabBar[data-orientation="vertical"] .p-TabBar-content-container>.ps__rail-y {
  width: var(--theia-private-horizontal-tab-scrollbar-rail-height);
  z-index: 1000;
}

.p-TabBar[data-orientation="vertical"] .p-TabBar-content-container>.ps__rail-y>.ps__thumb-y {
  width: var(--theia-private-horizontal-tab-scrollbar-height) !important;
  right: calc((var(--theia-private-horizontal-tab-scrollbar-rail-height) - var(--theia-private-horizontal-tab-scrollbar-height)) / 2);
}

.p-TabBar[data-orientation="vertical"] .p-TabBar-content-container {
  display: block;
}

/*-----------------------------------------------------------------------------
| Dragged tabs
|----------------------------------------------------------------------------*/

.p-TabBar-tab.p-mod-drag-image {
  transform: translateX(-40%) translateY(-58%);
  opacity: 0.8;
  line-height: var(--theia-private-horizontal-tab-height);
  height: var(--theia-private-horizontal-tab-height);
  min-height: var(--theia-private-horizontal-tab-height);
  padding: 0px 10px;
  font-size: var(--theia-ui-font-size1);
  background: var(--theia-editorGroupHeader-tabsBackground);
  border: var(--theia-border-width) solid var(--theia-contrastBorder);
  box-shadow: 1px 1px 2px var(--theia-widget-shadow);
  display: flex;
  align-items: center;
}

/*-----------------------------------------------------------------------------
| Tab-bar toolbar
|----------------------------------------------------------------------------*/

.p-TabBar-toolbar {
  z-index: var(--theia-tabbar-toolbar-z-index);
  /* Due to the scrollbar (\`z-index: 1000;\`) it has a greater \`z-index\`. */
  display: flex;
  flex-direction: row-reverse;
  padding: 4px;
  padding-left: 0px;
  margin-right: 4px;
}

.p-TabBar-content-container {
  display: flex;
  flex: 1;
  position: relative;
  /* This is necessary for perfect-scrollbar */
}

.p-TabBar-toolbar .item {
  opacity: var(--theia-mod-disabled-opacity);
  cursor: default;
  display: flex;
  flex-direction: row;
  column-gap: 0px;
  align-items: centery;
}

.p-TabBar-toolbar .item>div {
  height: 100%;
}

.p-TabBar-toolbar .item.enabled {
  opacity: 1;
  cursor: pointer;
}

.p-TabBar-toolbar :not(.item.enabled) .action-label {
  background: transparent;
  cursor: default;
}

.p-TabBar-toolbar .item.toggled {
  border: var(--theia-border-width) var(--theia-inputOption-activeBorder) solid;
  background-color: var(--theia-inputOption-activeBackground);
}

.p-TabBar-toolbar .item>div {
  line-height: calc(var(--theia-icon-size) + 2px);
  height: calc(var(--theia-icon-size) + 2px);
  background-repeat: no-repeat;
  line-height: 18px;
}

.p-TabBar-toolbar .item>div.no-icon {
  /* Make room for a text label instead of an icon. */
  width: 100%;
}

.p-TabBar-toolbar .item .collapse-all {
  background: var(--theia-icon-collapse-all) no-repeat;
}

.p-TabBar-toolbar .item .close {
  background: var(--theia-icon-collapse-all) no-repeat;
}

.p-TabBar-toolbar .item .clear-all {
  background: var(--theia-icon-clear) no-repeat;
}

.p-TabBar-toolbar .item .refresh {
  background: var(--theia-icon-refresh) no-repeat;
}

.p-TabBar-toolbar .item .cancel {
  background: var(--theia-icon-close) no-repeat;
}

/**
 * The chevron for the pop-up menu indication is shrunk and
 * stuffed in the bottom-right corner.
 */
.p-TabBar-toolbar .item.menu .chevron {
  font-size: 8px;
  vertical-align: bottom;
}

#theia-main-content-panel .p-TabBar:not(.theia-tabBar-active) .p-TabBar-toolbar {
  display: none;
}

.theia-tabBar-breadcrumb-row {
  min-width: 100%;
}

.p-TabBar.theia-tabBar-multirow[data-orientation="horizontal"] {
  min-height: calc(var(--theia-breadcrumbs-height) + var(--theia-horizontal-toolbar-height));
  flex-direction: column;
}

.p-TabBar[data-orientation="horizontal"] .theia-tabBar-tab-row {
  display: flex;
  flex-flow: row nowrap;
  min-width: 100%;
}

.p-TabBar[data-orientation="vertical"] .theia-tabBar-tab-row {
  display: flex;
  flex-flow: column nowrap;
  height: 100%;
}

.p-TabBar[data-orientation="horizontal"] .p-TabBar-content {
  flex-direction: row;
}

.p-TabBar[data-orientation="vertical"] .p-TabBar-content {
  flex-direction: column;
}

.p-TabBar.theia-app-centers[data-orientation="horizontal"].dynamic-tabs .p-TabBar-tabLabel {
  /* fade out text with dynamic tabs strategy */
  mask-image: linear-gradient(to left,
      rgba(0, 0, 0, 0.3),
      rgba(0, 0, 0, 1) 15px);
  -webkit-mask-image: linear-gradient(to left,
      rgba(0, 0, 0, 0.3),
      rgba(0, 0, 0, 1) 15px);
  flex: 1;
}

.p-TabBar[data-orientation="horizontal"] .p-TabBar-tab .theia-tab-icon-label {
  flex: 1;
  overflow: hidden;
}

.theia-horizontal-tabBar-hover-div {
  margin: 0px 4px;
}

.enhanced-preview-container {
  margin: 4px 4px;
  pointer-events: none;
  background: var(--theia-editor-background);
  position: relative;
  overflow: hidden;
}

.enhanced-preview {
  transform-origin: top left;
}

.theia-horizontal-tabBar-hover-title {
  font-weight: bolder;
  max-width: var(--theia-hover-preview-width);
  word-wrap: break-word;
  font-size: medium;
  margin: 0px 0px;
}

.theia-horizontal-tabBar-hover-caption {
  font-size: small;
  max-width: var(--theia-hover-preview-width);
  word-wrap: break-word;
  margin: 0px 0px;
  margin-top: 4px;
}

/*-----------------------------------------------------------------------------
| Open tabs dropdown
|----------------------------------------------------------------------------*/
.theia-tabBar-open-tabs>.theia-select-component .theia-select-component-label {
  display: none;
}

.theia-tabBar-open-tabs>.theia-select-component {
  min-width: auto;
  height: 100%;
}

.theia-tabBar-open-tabs {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
}

.theia-tabBar-open-tabs.p-mod-hidden {
  display: none;
}`, "",{"version":3,"sources":["webpack://./../node_modules/@theia/core/src/browser/style/tabs.css"],"names":[],"mappings":"AAAA;;8EAE8E;;AAE9E;EACE,iFAAiF;EACjF,6CAA6C;EAC7C,yDAAyD;EACzD,oDAAoD;EACpD,oCAAoC;EACpC,mDAAmD;EACnD,mJAAmJ;EACnJ,sCAAsC;AACxC;;AAEA;;8EAE8E;;AAE9E;EACE,qCAAqC;AACvC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,8CAA8C;EAC9C,eAAe;EACf,uDAAuD;EACvD,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,+EAA+E;EAC/E,kFAAkF;AACpF;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,qEAAqE;AACvE;;AAEA;;EAEE,aAAa;EACb,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;;8EAE8E;;AAE9E;;EAEE,0CAA0C;AAC5C;;AAEA;EACE,4EAA4E;AAC9E;;AAEA;EACE,2EAA2E;AAC7E;;AAEA;EACE,+CAA+C;EAC/C,iCAAiC;EACjC,oCAAoC;EACpC,+CAA+C;EAC/C,0CAA0C;AAC5C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,oBAAoB;EACpB,2DAA2D;EAC3D,WAAW;EACX,WAAW;AACb;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;EACzC,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6CAA6C;EAC7C,eAAe;EACf,qCAAqC;EACrC,gBAAgB;EAChB,+BAA+B;;EAE/B,wBAAwB;EACxB,qBAAqB;EACrB;;;8EAG4E;EAC5E,uEAAuE;EACvE,wBAAwB;EACxB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,iBAAiB;AACjB;;EAEE,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;EAC1B,wCAAwC;EACxC,8BAA8B;EAC9B,4BAA4B;EAC5B,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA,aAAa;AACb;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,eAAe;AACf;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,6BAA6B;EAC7B,yCAAyC;EACzC,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,mCAAmC;EACnC,kCAAkC;EAClC,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,6CAA6C;EAC7C,aAAa;AACf;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0DAA0D;EAC1D,mBAAmB;EACnB,+CAA+C;EAC/C,kDAAkD;EAClD,gBAAgB;EAChB,8CAA8C;EAC9C,4CAA4C;EAC5C,0CAA0C;EAC1C,yDAAyD;EACzD,kBAAkB;EAClB,sCAAsC;EACtC,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;EAC/C,mBAAmB;EACnB,sBAAsB;EACtB,+CAA+C;EAC/C,iDAAiD;EACjD,gBAAgB;EAChB,8CAA8C;EAC9C,4CAA4C;EAC5C,0CAA0C;EAC1C,0DAA0D;EAC1D,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;;8EAE8E;;AAE9E;EACE,iEAAiE;EACjE,aAAa;AACf;;AAEA;EACE,uEAAuE;EACvE,oIAAoI;AACtI;;AAEA;;EAEE,4EAA4E;AAC9E;;AAEA;;EAEE,iFAAiF;EACjF,oIAAoI;AACtI;;AAEA;EACE,gEAAgE;EAChE,aAAa;AACf;;AAEA;EACE,sEAAsE;EACtE,mIAAmI;AACrI;;AAEA;EACE,cAAc;AAChB;;AAEA;;8EAE8E;;AAE9E;EACE,4CAA4C;EAC5C,YAAY;EACZ,uDAAuD;EACvD,kDAAkD;EAClD,sDAAsD;EACtD,iBAAiB;EACjB,qCAAqC;EACrC,yDAAyD;EACzD,mEAAmE;EACnE,kDAAkD;EAClD,aAAa;EACb,mBAAmB;AACrB;;AAEA;;8EAE8E;;AAE9E;EACE,4CAA4C;EAC5C,wEAAwE;EACxE,aAAa;EACb,2BAA2B;EAC3B,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,0CAA0C;EAC1C,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,6EAA6E;EAC7E,2DAA2D;AAC7D;;AAEA;EACE,+CAA+C;EAC/C,0CAA0C;EAC1C,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,mDAAmD;EACnD,WAAW;AACb;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;;;EAGE;AACF;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0FAA0F;EAC1F,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,6CAA6C;EAC7C;;4BAE0B;EAC1B;;4BAE0B;EAC1B,OAAO;AACT;;AAEA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;EAC3C,qBAAqB;EACrB,eAAe;EACf,eAAe;AACjB;;AAEA;;8EAE8E;AAC9E;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf","sourcesContent":["/*-----------------------------------------------------------------------------\n| Variables\n|----------------------------------------------------------------------------*/\n\n:root {\n  /* These need to be root because tabs get attached to the body during dragging. */\n  --theia-private-horizontal-tab-height: 28.5px;\n  --theia-private-horizontal-tab-scrollbar-rail-height: 7px;\n  --theia-private-horizontal-tab-scrollbar-height: 5px;\n  --theia-tabbar-toolbar-z-index: 1001;\n  --theia-toolbar-active-transform-scale: 1.272019649;\n  --theia-horizontal-toolbar-height: calc(var(--theia-private-horizontal-tab-height) + var(--theia-private-horizontal-tab-scrollbar-rail-height) / 2);\n  --theia-dragover-tab-border-width: 2px;\n}\n\n/*-----------------------------------------------------------------------------\n| General tab bar style\n|----------------------------------------------------------------------------*/\n\n.p-TabBar {\n  font-size: var(--theia-ui-font-size1);\n}\n\n.p-TabBar[data-orientation=\"horizontal\"] {\n  min-height: var(--theia-horizontal-toolbar-height);\n}\n\n.p-TabBar .p-TabBar-content {\n  cursor: pointer;\n}\n\n.p-TabBar[data-orientation=\"horizontal\"] .p-TabBar-tab {\n  flex: none;\n  height: var(--theia-horizontal-toolbar-height);\n  min-width: 35px;\n  line-height: var(--theia-private-horizontal-tab-height);\n  padding: 0px 8px;\n  align-items: center;\n  overflow: hidden;\n}\n\n.p-TabBar[data-orientation=\"vertical\"] .p-TabBar-tab {\n  border-top: var(--theia-dragover-tab-border-width) solid transparent !important;\n  border-bottom: var(--theia-dragover-tab-border-width) solid transparent !important;\n}\n\n.p-TabBar[data-orientation=\"vertical\"] .p-TabBar-tab.drop-target-top {\n  border-top-color: var(--theia-activityBar-activeBorder) !important;\n}\n\n.p-TabBar[data-orientation=\"vertical\"] .p-TabBar-tab.drop-target-bottom {\n  border-bottom-color: var(--theia-activityBar-activeBorder) !important;\n}\n\n.p-TabBar[data-orientation=\"horizontal\"] .p-TabBar-tab .theia-tab-icon-label,\n.p-TabBar-tab.p-mod-drag-image .theia-tab-icon-label {\n  display: flex;\n  line-height: var(--theia-content-line-height);\n  align-items: center;\n}\n\n/*-----------------------------------------------------------------------------\n| Tabs in the center area (main and bottom)\n|----------------------------------------------------------------------------*/\n\n#theia-main-content-panel,\n#theia-main-content-panel .p-Widget.p-DockPanel-widget {\n  background: var(--theia-editor-background);\n}\n\n#theia-main-content-panel .p-DockPanel-handle[data-orientation=\"horizontal\"] {\n  border-left: var(--theia-border-width) solid var(--theia-editorGroup-border);\n}\n\n#theia-main-content-panel .p-DockPanel-handle[data-orientation=\"vertical\"]+.p-TabBar {\n  border-top: var(--theia-border-width) solid var(--theia-editorGroup-border);\n}\n\n#theia-main-content-panel .p-TabBar .p-TabBar-tab {\n  border-right: 1px solid var(--theia-tab-border);\n  border-top: 1px solid transparent;\n  border-bottom: 1px solid transparent;\n  background: var(--theia-tab-inactiveBackground);\n  color: var(--theia-tab-inactiveForeground);\n}\n\n#theia-main-content-panel .p-TabBar:not(.theia-tabBar-active) .p-TabBar-tab {\n  color: var(--theia-tab-unfocusedInactiveForeground);\n}\n\n.p-TabBar.theia-app-centers {\n  background: var(--theia-editorGroupHeader-tabsBackground);\n}\n\n.p-TabBar.theia-app-centers::after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  pointer-events: none;\n  background-color: var(--theia-editorGroupHeader-tabsBorder);\n  width: 100%;\n  height: 1px;\n}\n\n.p-TabBar.theia-app-centers .p-TabBar-tabIcon,\n.p-TabBar.theia-app-centers .p-TabBar-tabLabel,\n.p-TabBar.theia-app-centers .p-TabBar-tabLabelDetails,\n.p-TabBar.theia-app-centers .p-TabBar-tabCloseIcon {\n  display: inline-block;\n}\n\n.p-TabBar.theia-app-centers .p-TabBar-tabLabelDetails {\n  margin-left: 5px;\n  color: var(--theia-descriptionForeground);\n  flex: 1 1 auto;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.p-TabBar-tail {\n  padding-left: 5px;\n  text-align: center;\n  justify-content: center;\n}\n\n.p-TabBar.theia-app-centers .p-TabBar-tabLabelWrapper {\n  display: flex;\n}\n\n.p-TabBar-tab-secondary-label {\n  color: var(--theia-settings-headerForeground);\n  cursor: pointer;\n  font-size: var(--theia-ui-font-size0);\n  margin-left: 5px;\n  text-decoration-line: underline;\n\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background-image: linear-gradient(45deg,\n      transparent 50%,\n      var(--theia-icon-foreground) 50%),\n    linear-gradient(135deg, var(--theia-icon-foreground) 50%, transparent 50%);\n  background-position: calc(100% - 6px) 8px, calc(100% - 2px) 8px, 100% 0;\n  background-size: 4px 5px;\n  background-repeat: no-repeat;\n  padding: 2px 14px 0 0;\n}\n\n.p-TabBar .p-TabBar-tabIcon,\n.p-TabBar-tab.p-mod-drag-image .p-TabBar-tabIcon {\n  width: 15px;\n  line-height: 1.7;\n  font-size: 12px;\n  text-align: center;\n  background-repeat: no-repeat;\n}\n\n/* common icons */\n.p-TabBar.theia-app-centers .p-TabBar-tabIcon,\n.p-TabBar-tab.p-mod-drag-image .p-TabBar-tabIcon {\n  min-height: 14px;\n  background-size: 13px;\n  background-position-y: 3px;\n  background: var(--theia-icon-foreground);\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-size: auto 13px;\n  mask-repeat: no-repeat;\n  mask-size: auto 13px;\n  padding-right: 8px;\n}\n\n.p-TabBar.theia-app-centers .p-TabBar-tabIcon[class*=\"plugin-icon-\"],\n.p-TabBar-tab.p-mod-drag-image .p-TabBar-tabIcon[class*=\"plugin-icon-\"] {\n  background: none;\n  height: var(--theia-icon-size);\n}\n\n.p-TabBar.theia-app-centers .p-TabBar-tabIcon[class*=\"plugin-icon-\"]::before,\n.p-TabBar-tab.p-mod-drag-image .p-TabBar-tabIcon[class*=\"plugin-icon-\"]::before {\n  display: inline-block;\n}\n\n/* codicons */\n.p-TabBar.theia-app-centers .p-TabBar-tabIcon.codicon,\n.p-TabBar-tab.p-mod-drag-image .p-TabBar-tabIcon.codicon {\n  background: none;\n}\n\n.p-TabBar-tabLock:after {\n  content: \"\\ebe7\";\n  opacity: 0.75;\n  margin-left: 4px;\n  color: inherit;\n  font-family: codicon;\n  font-size: 16px;\n  font-weight: normal;\n  display: inline-block;\n  vertical-align: top;\n}\n\n/* file icons */\n.p-TabBar[data-orientation=\"horizontal\"] .p-TabBar-tabIcon.file-icon,\n.p-TabBar-tab.p-mod-drag-image .p-TabBar-tabIcon.file-icon {\n  background: none;\n  padding-bottom: 0px;\n  min-height: 20px;\n}\n\n.p-TabBar[data-orientation=\"horizontal\"] .p-TabBar-tabIcon.fa,\n.p-TabBar-tab.p-mod-drag-image .p-TabBar-tabIcon.fa {\n  background: none;\n  min-height: 0;\n  height: inherit;\n}\n\n.p-TabBar[data-orientation=\"vertical\"] .p-TabBar-tab.p-mod-invisible {\n  visibility: hidden;\n}\n\n.p-TabBar.theia-app-centers .p-TabBar-tab.p-mod-closable>.p-TabBar-tabCloseIcon,\n.p-TabBar.theia-app-centers .p-TabBar-tab.theia-mod-pinned>.p-TabBar-tabCloseIcon {\n  padding: 2px;\n  margin-top: 2px;\n  margin-left: 4px;\n  height: var(--theia-icon-size);\n  width: var(--theia-icon-size);\n  font: normal normal normal 16px/1 codicon;\n  display: inline-block;\n  text-decoration: none;\n  text-rendering: auto;\n  text-align: center;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n}\n\n.p-TabBar.theia-app-centers.dynamic-tabs .p-TabBar-tab.p-mod-closable>.p-TabBar-tabCloseIcon,\n.p-TabBar.theia-app-centers.dynamic-tabs .p-TabBar-tab.theia-mod-pinned>.p-TabBar-tabCloseIcon {\n  /* hide close icon for dynamic tabs strategy*/\n  display: none;\n}\n\n.p-TabBar.theia-app-centers .p-TabBar-tab.p-mod-current>.p-TabBar-tabCloseIcon,\n.p-TabBar.theia-app-centers .p-TabBar-tab:hover.p-mod-closable>.p-TabBar-tabCloseIcon,\n.p-TabBar.theia-app-centers .p-TabBar-tab:hover.theia-mod-pinned>.p-TabBar-tabCloseIcon {\n  display: inline-block;\n}\n\n.p-TabBar.theia-app-centers .p-TabBar-tab.p-mod-closable>.p-TabBar-tabCloseIcon:hover {\n  border-radius: 5px;\n  background-color: rgba(50%, 50%, 50%, 0.2);\n}\n\n.p-TabBar.theia-app-centers .p-TabBar-tab.p-mod-closable,\n.p-TabBar.theia-app-centers .p-TabBar-tab.theia-mod-pinned {\n  padding-right: 4px;\n}\n\n.p-TabBar.theia-app-centers .p-TabBar-tab.p-mod-closable:not(.theia-mod-dirty):hover>.p-TabBar-tabCloseIcon:before,\n.p-TabBar.theia-app-centers .p-TabBar-tab.p-mod-closable:not(.theia-mod-dirty).p-TabBar-tab.p-mod-current>.p-TabBar-tabCloseIcon:before,\n.p-TabBar.theia-app-centers .p-TabBar-tab.p-mod-closable.theia-mod-dirty>.p-TabBar-tabCloseIcon:hover:before {\n  content: \"\\ea76\";\n}\n\n.p-TabBar.theia-app-centers .p-TabBar-tab.p-mod-closable.theia-mod-dirty>.p-TabBar-tabCloseIcon:before {\n  content: \"\\ea71\";\n}\n\n.p-TabBar.theia-app-centers .p-TabBar-tab.theia-mod-pinned>.p-TabBar-tabCloseIcon:before {\n  content: \"\\eba0\";\n}\n\n.p-TabBar.theia-app-centers .p-TabBar-tab.theia-mod-pinned.theia-mod-dirty>.p-TabBar-tabCloseIcon:before {\n  content: \"\\ebb2\";\n}\n\n.p-TabBar-tabIcon.no-icon {\n  display: none !important;\n}\n\n.theia-badge-decorator-sidebar {\n  background-color: var(--theia-activityBarBadge-background);\n  border-radius: 20px;\n  color: var(--theia-activityBarBadge-foreground);\n  font-size: calc(var(--theia-ui-font-size0) * 0.85);\n  font-weight: 600;\n  height: var(--theia-notification-count-height);\n  width: var(--theia-notification-count-width);\n  padding: calc(var(--theia-ui-padding) / 6);\n  line-height: calc(var(--theia-content-line-height) * 0.7);\n  position: absolute;\n  top: calc(var(--theia-ui-padding) * 4);\n  right: calc(var(--theia-ui-padding) * 1.33);\n  text-align: center;\n}\n\n.p-TabBar .theia-badge-decorator-horizontal {\n  background-color: var(--theia-badge-background);\n  border-radius: 20px;\n  box-sizing: border-box;\n  color: var(--theia-activityBarBadge-foreground);\n  font-size: calc(var(--theia-ui-font-size0) * 0.8);\n  font-weight: 400;\n  height: var(--theia-notification-count-height);\n  width: var(--theia-notification-count-width);\n  padding: calc(var(--theia-ui-padding) / 6);\n  line-height: calc(var(--theia-content-line-height) * 0.61);\n  margin-left: var(--theia-ui-padding);\n  text-align: center;\n}\n\n/*-----------------------------------------------------------------------------\n| Perfect scrollbar\n|----------------------------------------------------------------------------*/\n\n.p-TabBar[data-orientation=\"horizontal\"] .p-TabBar-content-container>.ps__rail-x {\n  height: var(--theia-private-horizontal-tab-scrollbar-rail-height);\n  z-index: 1000;\n}\n\n.p-TabBar[data-orientation=\"horizontal\"] .p-TabBar-content-container>.ps__rail-x>.ps__thumb-x {\n  height: var(--theia-private-horizontal-tab-scrollbar-height) !important;\n  bottom: calc((var(--theia-private-horizontal-tab-scrollbar-rail-height) - var(--theia-private-horizontal-tab-scrollbar-height)) / 2);\n}\n\n.p-TabBar[data-orientation=\"horizontal\"] .p-TabBar-content-container>.ps__rail-x:hover,\n.p-TabBar[data-orientation=\"horizontal\"] .p-TabBar-content-container>.ps__rail-x:focus {\n  height: var(--theia-private-horizontal-tab-scrollbar-rail-height) !important;\n}\n\n.p-TabBar[data-orientation=\"horizontal\"] .p-TabBar-content-container>.ps__rail-x:hover>.ps__thumb-x,\n.p-TabBar[data-orientation=\"horizontal\"] .p-TabBar-content-container>.ps__rail-x:focus>.ps__thumb-x {\n  height: calc(var(--theia-private-horizontal-tab-scrollbar-height) / 2) !important;\n  bottom: calc((var(--theia-private-horizontal-tab-scrollbar-rail-height) - var(--theia-private-horizontal-tab-scrollbar-height)) / 2);\n}\n\n.p-TabBar[data-orientation=\"vertical\"] .p-TabBar-content-container>.ps__rail-y {\n  width: var(--theia-private-horizontal-tab-scrollbar-rail-height);\n  z-index: 1000;\n}\n\n.p-TabBar[data-orientation=\"vertical\"] .p-TabBar-content-container>.ps__rail-y>.ps__thumb-y {\n  width: var(--theia-private-horizontal-tab-scrollbar-height) !important;\n  right: calc((var(--theia-private-horizontal-tab-scrollbar-rail-height) - var(--theia-private-horizontal-tab-scrollbar-height)) / 2);\n}\n\n.p-TabBar[data-orientation=\"vertical\"] .p-TabBar-content-container {\n  display: block;\n}\n\n/*-----------------------------------------------------------------------------\n| Dragged tabs\n|----------------------------------------------------------------------------*/\n\n.p-TabBar-tab.p-mod-drag-image {\n  transform: translateX(-40%) translateY(-58%);\n  opacity: 0.8;\n  line-height: var(--theia-private-horizontal-tab-height);\n  height: var(--theia-private-horizontal-tab-height);\n  min-height: var(--theia-private-horizontal-tab-height);\n  padding: 0px 10px;\n  font-size: var(--theia-ui-font-size1);\n  background: var(--theia-editorGroupHeader-tabsBackground);\n  border: var(--theia-border-width) solid var(--theia-contrastBorder);\n  box-shadow: 1px 1px 2px var(--theia-widget-shadow);\n  display: flex;\n  align-items: center;\n}\n\n/*-----------------------------------------------------------------------------\n| Tab-bar toolbar\n|----------------------------------------------------------------------------*/\n\n.p-TabBar-toolbar {\n  z-index: var(--theia-tabbar-toolbar-z-index);\n  /* Due to the scrollbar (`z-index: 1000;`) it has a greater `z-index`. */\n  display: flex;\n  flex-direction: row-reverse;\n  padding: 4px;\n  padding-left: 0px;\n  margin-right: 4px;\n}\n\n.p-TabBar-content-container {\n  display: flex;\n  flex: 1;\n  position: relative;\n  /* This is necessary for perfect-scrollbar */\n}\n\n.p-TabBar-toolbar .item {\n  opacity: var(--theia-mod-disabled-opacity);\n  cursor: default;\n  display: flex;\n  flex-direction: row;\n  column-gap: 0px;\n  align-items: centery;\n}\n\n.p-TabBar-toolbar .item>div {\n  height: 100%;\n}\n\n.p-TabBar-toolbar .item.enabled {\n  opacity: 1;\n  cursor: pointer;\n}\n\n.p-TabBar-toolbar :not(.item.enabled) .action-label {\n  background: transparent;\n  cursor: default;\n}\n\n.p-TabBar-toolbar .item.toggled {\n  border: var(--theia-border-width) var(--theia-inputOption-activeBorder) solid;\n  background-color: var(--theia-inputOption-activeBackground);\n}\n\n.p-TabBar-toolbar .item>div {\n  line-height: calc(var(--theia-icon-size) + 2px);\n  height: calc(var(--theia-icon-size) + 2px);\n  background-repeat: no-repeat;\n  line-height: 18px;\n}\n\n.p-TabBar-toolbar .item>div.no-icon {\n  /* Make room for a text label instead of an icon. */\n  width: 100%;\n}\n\n.p-TabBar-toolbar .item .collapse-all {\n  background: var(--theia-icon-collapse-all) no-repeat;\n}\n\n.p-TabBar-toolbar .item .close {\n  background: var(--theia-icon-collapse-all) no-repeat;\n}\n\n.p-TabBar-toolbar .item .clear-all {\n  background: var(--theia-icon-clear) no-repeat;\n}\n\n.p-TabBar-toolbar .item .refresh {\n  background: var(--theia-icon-refresh) no-repeat;\n}\n\n.p-TabBar-toolbar .item .cancel {\n  background: var(--theia-icon-close) no-repeat;\n}\n\n/**\n * The chevron for the pop-up menu indication is shrunk and\n * stuffed in the bottom-right corner.\n */\n.p-TabBar-toolbar .item.menu .chevron {\n  font-size: 8px;\n  vertical-align: bottom;\n}\n\n#theia-main-content-panel .p-TabBar:not(.theia-tabBar-active) .p-TabBar-toolbar {\n  display: none;\n}\n\n.theia-tabBar-breadcrumb-row {\n  min-width: 100%;\n}\n\n.p-TabBar.theia-tabBar-multirow[data-orientation=\"horizontal\"] {\n  min-height: calc(var(--theia-breadcrumbs-height) + var(--theia-horizontal-toolbar-height));\n  flex-direction: column;\n}\n\n.p-TabBar[data-orientation=\"horizontal\"] .theia-tabBar-tab-row {\n  display: flex;\n  flex-flow: row nowrap;\n  min-width: 100%;\n}\n\n.p-TabBar[data-orientation=\"vertical\"] .theia-tabBar-tab-row {\n  display: flex;\n  flex-flow: column nowrap;\n  height: 100%;\n}\n\n.p-TabBar[data-orientation=\"horizontal\"] .p-TabBar-content {\n  flex-direction: row;\n}\n\n.p-TabBar[data-orientation=\"vertical\"] .p-TabBar-content {\n  flex-direction: column;\n}\n\n.p-TabBar.theia-app-centers[data-orientation=\"horizontal\"].dynamic-tabs .p-TabBar-tabLabel {\n  /* fade out text with dynamic tabs strategy */\n  mask-image: linear-gradient(to left,\n      rgba(0, 0, 0, 0.3),\n      rgba(0, 0, 0, 1) 15px);\n  -webkit-mask-image: linear-gradient(to left,\n      rgba(0, 0, 0, 0.3),\n      rgba(0, 0, 0, 1) 15px);\n  flex: 1;\n}\n\n.p-TabBar[data-orientation=\"horizontal\"] .p-TabBar-tab .theia-tab-icon-label {\n  flex: 1;\n  overflow: hidden;\n}\n\n.theia-horizontal-tabBar-hover-div {\n  margin: 0px 4px;\n}\n\n.enhanced-preview-container {\n  margin: 4px 4px;\n  pointer-events: none;\n  background: var(--theia-editor-background);\n  position: relative;\n  overflow: hidden;\n}\n\n.enhanced-preview {\n  transform-origin: top left;\n}\n\n.theia-horizontal-tabBar-hover-title {\n  font-weight: bolder;\n  max-width: var(--theia-hover-preview-width);\n  word-wrap: break-word;\n  font-size: medium;\n  margin: 0px 0px;\n}\n\n.theia-horizontal-tabBar-hover-caption {\n  font-size: small;\n  max-width: var(--theia-hover-preview-width);\n  word-wrap: break-word;\n  margin: 0px 0px;\n  margin-top: 4px;\n}\n\n/*-----------------------------------------------------------------------------\n| Open tabs dropdown\n|----------------------------------------------------------------------------*/\n.theia-tabBar-open-tabs>.theia-select-component .theia-select-component-label {\n  display: none;\n}\n\n.theia-tabBar-open-tabs>.theia-select-component {\n  min-width: auto;\n  height: 100%;\n}\n\n.theia-tabBar-open-tabs {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n}\n\n.theia-tabBar-open-tabs.p-mod-hidden {\n  display: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
